export default {
  OK: "đồng ý",
  ok: "đồng ý",
  loginFailed: "Đăng nhập thất bại. Xin hãy thử lại.",
  requestFailed: "Yêu cầu thất bại, xin vui lòng kiểm tra kết nối internet của bạn.",
  invalidLogin: "Sai tên đăng nhập hoặc mật khẩu",
  invalidPassword: "Sai tên đăng nhập hoặc mật khẩu",
  thisFunctionExists: "Chức năng này đã tồn tại.",
  thisFunctionNotAllowDelete: "Chức năng này không cho phép xóa.",
  thisFunctionNotExists: "Chức năng này không tồn tại.",
  targetFunctionIdRequired: "Mục tiêu Chức năng ID là bắt buộc.",
  thisPageExists: "Trang này là đã tồn tại.",
  thisPageNotAllowDelete: "Trang này không cho phép xóa.",
  thisRoleExists: "Vai trò này là đã tồn tại.",
  thisRoleNotAllowDelete: "Vai trò này không cho phép xóa.",
  targetRoleIdRequired: "Mục tiêu vai trò ID là bắt buộc.",
  invalidParameter: "Tham số không hợp lệ.",
  systemError: "Hệ thống không thể xử lý yêu cầu của bạn.",
  spErrorMessage: "SP Thông báo lỗi (Tùy gì lỗi).",
  actionbyRequired: "Người dùng hiện tại là bắt buộc",
  sessionTokenRequired: "Phiên Mã là bắt buộc.",
  functionIdRequired: "Chức năng ID là bắt buộc.",
  functionNameRequired: "Tên chức năng là bắt buộc",
  newFunctionNameRequired: "Tên chức năng là bắt buộc",
  pageIdRequired: "Trang ID là bắt buộc.",
  newPageIdRequired: "Trang ID là bắt buộc.",
  newPageNameRequired: "Tên trang là bắt buộc.",
  targetPageIdRequired: "Mục tiêu trang ID là bắt buộc.",
  userIdRequired: "Tên người dùng là bắt buộc",
  passwordRequired: "Mật khẩu là bắt buộc.",
  userNameRequired: "Tên đầy đủ là bắt buộc.",
  passwordValidation: "Mật khẩu phải gồm 6-20 ký tự và một sự kết hợp của số (s) và chữ cái (s).",
  pageNumRequired: "Trang Số là bắt buộc.",
  pageSizeRequired: "Kích thước trang là bắt buộc.",
  roleIdRequired: "Tên vai trò là cần thiết",
  oldPasswordRequired: "Mật khẩu hiện tại là bắt buộc.",
  userStatusRequired: "Tài trạng người dùng là bắt buộc.",
  newRoleIdRequired: "Tên vai trò là bắt buộc.",
  newRoleNameRequired: "Tên vai trò là bắt buộc.",
  startDateRequired: "Ngày bắt đầu là bắt buộc.",
  endDateRequired: "Ngày Kết thúc là bắt buộc.",
  startDateIsGteEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  sportsTypeRequired: "Thể thao Loại là bắt buộc.",
  teamTypeRequired: "Thể loại đội là bắt buộc.",
  thisRoleNotExists: "Vai trò này không tồn tại.",
  thisPageNotExists: "Trang này không tồn tại.",
  thisUserExists: "Tài khoản này đã tồn tại.",
  thisUserNotExists: "Thành viên này không tồn tại.",
  thisUserBlackListed: "Tài khoản của bạn đã bị tạm khóa.",
  thisUserInactive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  thisUserBlocked: "Tài khoản của bạn đã bị khóa.",
  thisUserNotActive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  InvalidPageFunction:"Chức năng trang không hợp lệ.",
  invalidUser: "Người dùng không hợp lệ!",
  invalidToken: "Phiên không hợp lệ !",
  NoUserAccessRight: "Quyền bị từ chối!",
  unableSPProcess: "Hệ thống không thể xử lý yêu cầu của bạn.",
  connection: "Lỗi kết nối",

  isRequired: "Vui lòng nhập một {fname}.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isMaxValue: "{fname} Tên phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} giá trị ký tự.",
  isMaxLength: "{fname} Tên phải nhỏ hơn hoặc bằng {fvalue} giá trị ký tự.",
  isAlpha: "{fname} chỉ chấp nhận bảng chữ cái.",
  isAlphaNum: "{fname} tên chấp nhận chữ cái và số.",
  isNumeric: "{fname} chỉ chấp nhận chữ số",
  isEmail: "{fname} tên chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} tên chấp nhận địa chỉ IPv4 chỉ có giá trị.",
  isSameAs: "{fname} phải được giống như {fname2}.",
  isUrl: "{fname} chỉ chấp nhận URL.",
  containAlphaNum: "{fname} phải có ít nhất một chữ cái và một số.",
  selectOption: "Vui lòng chọn {fname}",
  notSameAs: "{fname} và {fname2} tên2 không thể giống nhau.",
  isBetween: "{fname} phải được giữa {min} và {max}.",
  isSSFormat: "Invalid Super Senior account id format.",
  isReserved: "Reserved account id.",
  isExisted: "Tên Đăng Nhập tồn tại.",
  onlySmallCapsAlphaNum: "chỉ có chữ in hoa nhỏ Từ a to z & 0 to 9",

  system_error: "Hệ thống không thể xử lý yêu cầu của bạn.",
  invalid_password: "ai tên đăng nhập hoặc mật khẩu.",
  block: "Tài khoản của bạn đã bị khóa.",
  invalid_security_code: "Mã bảo mật không hợp lệ.",

  source_account_id_required: "Tên tài khoản là bắt buộc.",
  target_account_id_required: "Mục tiêu tên tài khoản là bắt buộc.",
  permission_denied: "Không có quyền cho phép.",
  account_id_required: "Tên tài khoản là bắt buộc.",
  sub_login_id_required: "Tên đăng nhập là bắt buộc.",
  account_not_exists: "Tài khoản không tồn tại.",
  profile_not_exists: "Hồ sơ không tồn tại.",
  account_inactive: "Tài khoản không hoạt động.",
  not_blocked_account: "Tài khoản hợp lệ.",
  password_required: "Mật khẩu là bắt buộc.",
  parent_id_required: "Tên cấp cha là bắt buộc.",
  parent_not_exists:"Tên cấp cha không hợp lệ.",
  invalid_account_type: "Loại tài khoản không hợp lệ.",
  account_exists: "Tài khoản đã tồn tại.",
  login_id_required: "Tên đăng nhập là bắt buộc.",
  new_login_id_required: "Tên đăng nhập mới là bắt buộc.",
  login_id_not_exists: "Tên đăng nhập không tồn tại.",
  invalid_authority_role: "Vai trò không hợp lệ.",
  profile_inactive: "Hồ sơ hợp lệ.",
  secondary_account_exists: "Tài khoản phụ là đã tồn tại.",
  new_login_id_exists: "Tên đăng nhập mới đã tồn tại",
  new_password_required: "Mật khẩu mới là bắt buộc.",
  security_tag_required: "Thẻ bảo mật là bắt buộc.",
  security_code_required: "Mã bảo mật là bắt buộc.",
  start_date_required: "Ngày bắt đầu là bắt buộc.",
  end_date_required: "Ngày kết thúc là bắt buộc.",
  start_date_gt_end_date: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  member_id_required: "Tên thành viên là bắt buộc",
  currency_code_required: "Mã tiền tệ là bắt buộc.",
  commission_setting_not_exists: "Thiết lập hoa hồng không tồn tại.",
  incomplete_account_line: "Không đầy đủ dòng tài khoản.",
  invalid_hdp_package: "Gói không hợp lệ HDP.",
  search_id_required: "Tên tìm kiếm là bắt buộc.",
  profile_id_required: "Tên hồ sơ là bắt buộc.",
  login_not_exists: "Đăng nhập không tồn tại.",
  no_changes: "Không có thay đổi được phát hiện.",
  start_date_require: "Ngày bắt đầu là bắt buộc.",
  league_id_required: "Tên giải đấu là bắt buộc.",
  sport_type_required: "Dạng thể thao là bắt buộc.",
  match_id_required: "Tên trận đấu là bắt buộc.",
  target_login_id_required: "Tên mục tiêu đăng nhập là bắt buộc.",
  parent_account_not_exists: "Tên tài khoản cha không tồn tại.",
  parent_account_inactive: "Tài khoản cha không hoạt động.",
  parent_profile_not_exists: "Hồ sơ cha không tồn tại.",
  parent_profile_inactive: "Hồ sơ cha không hoạt động.",
  target_login_id_not_exists: "Tên mục tiêu đăng nhập không tồn tại.",
  incorrect_parent: "Tên cha không hợp lệ.",
  invalid_session: "Yêu cầu phiên không hợp lệ.",
  session_expired: "Phiên hết hạn.",
  settle_amount_required: "Lượng thống kê là bắt buộc.",
  invalid_settle_amount: "Lượng thống kê không hợp lệ.",
  settle_amount_gt_yesterday_balance: "Lượng thống kê lớn hơn số dư ngày hôm qua.",
  invalid_account_status: "Tình trạng tài khoản không hợp lệ.",
  bet_limit_packages_required: "Gói giới hạn đặt cược được yêu cầu.",
  bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  member_bet_limit_package_gt_one: "Thành viên giới hạn đặt cược gói là nhiều hơn một.",
  parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  account_commission_required: "Hoa hồng tài khoản là bắt buộc.",
  commission_setting_exists: "Thiết lập hoa hồng đã tồn tại.",
  parent_comm_not_exists: "Thiết lập hoa hồng cấp cha không tồn tại.",
  exceeded_parent_comm: "Đã vượt quá thiết lập hoa hồng cấp cha.",
  others_commission_required: "Thiết lập hoa hồng khác là bắt buộc.",
  exceeded_parent_1x2: "Đã vượt quá thiết lập hoa hồng cấp cha 1x2.",
  exceeded_parent_other: "Đã vượt quá thiết lập hoa hồng  khác của cấp cha.",
  hdp_commission_required: "Thiết lập hoa hồng HDP là bắt buộc.",
  exceeded_parent_hdp_a: "Đã vượt quá thiết lập hoa hồng  HPD (A) cấp cha.",
  exceeded_parent_hdp_b: "Đã vượt quá thiết lập hoa hồng  HPD (B) cấp cha.",
  exceeded_parent_hdp_c: "Đã vượt quá thiết lập hoa hồng  HPD (C) cấp cha.",
  exceeded_parent_hdp_d: "Đã vượt quá thiết lập hoa hồng  HPD (D) cấp cha.",
  exceeded_parent_hdp_e: "Đã vượt quá thiết lập hoa hồng  HPD (E) cấp cha.",
  exceeded_parent_hdp_f: "Đã vượt quá thiết lập hoa hồng  HPD (F) cấp cha.",
  exceeded_parent_hdp_g: "Đã vượt quá thiết lập hoa hồng  HPD (G) cấp cha.",
  exceeded_parent_hdp_h: "Đã vượt quá thiết lập hoa hồng  HPD (H) cấp cha.",
  exceeded_parent_hdp_i: "Đã vượt quá thiết lập hoa hồng  HPD (I) cấp cha.",
  exceeded_parent_hdp_j: "Đã vượt quá thiết lập hoa hồng  HPD (J) cấp cha.",
  LIVECASINO_upline_pt_required: "[Sóng bạc trực tuyến] thiết lập Tuyến trên PT là bắt buộc.",
  LIVECASINO_pt_setting_exists: "[Sóng bạc trực tuyến] PT thiết lập là bắt buộc.",
  LIVECASINO_parent_pt_not_exists: "[Sóng bạc trực tuyến] Chuyên thiết lập PT không tồn tại.",
  LIVECASINO_parent_min_not_meet: "[Sóng bạc trực tuyến] không phù hợp với PT mẹ tối thiểu.",
  LIVECASINO_exceeded_parent_pt: "[Sóng bạc trực tuyến] không phù hợp với PT mẹ tối thiểu.",
  LIVECASINO_account_pt_required: "[Sóng bạc trực tuyến] thiết lập PT Tài khoản là bắt buộc.",
  LIVECASINO_upline_remaining_required: "[Sóng bạc trực tuyến] Tuyến trên thiết lập PT còn lại là bắt buộc.",
  LIVECASINO_account_min_required: "[Sóng bạc trực tuyến] Tài khoản tối thiểu PT thiết lập là bắt buộc.",
  LIVECASINO_upline_remaining_gt_account_pt: "[Sóng bạc trực tuyến] Tuyến trên thiết lập PT còn lại lớn hơn thiết lập tài khoản của PT.",
  LIVECASINO_account_min_gt_p: "[Sóng bạc trực tuyến] Tài khoản thiết lập PT tối thiểu lớn hơn thiết lập PT cấp cha.",
  SLOTS_upline_pt_required: "[Sóng bạc trực tuyến] thiết lập Tuyến trên PT là bắt buộc.",
  SLOTS_pt_setting_exists: "[Sóng bạc trực tuyến] thiết lập PT là bắt buộc.",
  SLOTS_parent_pt_not_exists: "[Sóng bạc trực tuyến] Chuyên thiết lập PT không tồn tại.",
  SLOTS_parent_min_not_meet: "[Sóng bạc trực tuyến] không phù hợp với PT mẹ tối thiểu.",
  SLOTS_exceeded_parent_pt: "[Sóng bạc trực tuyến] Đã vượt quá  PT cấp cha.",
  SLOTS_account_pt_required: "[Sóng bạc trực tuyến] thiết lập PT Tài khoản là bắt buộc.",
  SLOTS_upline_remaining_required: "[Sóng bạc trực tuyến] Tuyến trên thiết lập PT còn lại là bắt buộc.",
  SLOTS_account_min_required: "[Sóng bạc trực tuyến] Tài khoản tối thiểu PT thiết lập là bắt buộc.",
  SLOTS_upline_remaining_gt_account_pt: "[Sóng bạc trực tuyến] Tuyến trên thiết lập PT còn lại lớn hơn thiết lập tài khoản của PT.",
  SLOTS_account_min_gt_pt: "[Sóng bạc trực tuyến] Tài khoản thiết lập PT tối thiểu lớn hơn thiết lập PT cấp cha.",
  bet_type_required: "Loại đặt cược là cần thiết.",
  schedule_1_to_7_required: "Tiến độ giải quyết được yêu cầu.",
  schedule_exists: "Tiến độ giải quyết không tồn tại.",
  parent_schedule_not_exists: "Tiến độ giải quyết phụ huynh không tồn tại.",
  schedule_1_not_available: "Giải quyết hôm thứ Hai là không có sẵn.",
  schedule_2_not_available: "Giải quyết vào thứ ba là không có sẵn.",
  schedule_3_not_available: "Giải quyết hôm thứ tư là không có sẵn.",
  schedule_4_not_available: "Giải quyết hôm thứ Năm là không có sẵn.",
  schedule_5_not_available: "Giải quyết hôm thứ Sáu là không có sẵn.",
  schedule_6_not_available: "Giải quyết hôm thứ Bảy là không có sẵn.",
  schedule_7_not_available: "Giải quyết vào ngày chủ nhật không có sẵn.",
  credit_limit_required: "Hạn mức tín dụng là bắt buộc.",
  member_credit_limit_required: "Hạn mức tín dụng thành viên là bắt buộc.",
  wallet_exists: "Tài khoản đã tồn tại.",
  member_credit_limit_gt_credit_limit: "Hạn mức tín dụng thành viên lớn hơn hạn mức tín dụng.",
  parent_wallet_not_exists: "Tài khoản không tồn tại.",
  account_credit_limit_gt_parent: "Hạn mức tín dụng thành viên lớn hơn hạn mức tín dụng.",
  member_credit_limit_gt_parent: "Hạn mức tín dụng thành viên lớn hơn hạn mức tín dụng.",
  exceeded_credit_limit: "Hạn mức tín dụng tài khoản vượt quá.",
  
  soccer_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  soccer_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  soccer_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  soccer_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  soccer_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  soccer_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  soccer_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  soccer_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  basketball_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  basketball_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  basketball_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  basketball_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  basketball_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  basketball_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  basketball_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  basketball_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  tennis_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  tennis_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  tennis_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  tennis_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  tennis_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  tennis_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  tennis_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  tennis_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  baseball_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  baseball_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  baseball_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  baseball_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  baseball_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  baseball_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  baseball_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  baseball_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  parlay_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  parlay_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  parlay_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  parlay_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  parlay_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  parlay_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  parlay_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  parlay_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  esports_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  esports_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  esports_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  esports_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  esports_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  esports_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  esports_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  esports_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",
  
  others_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  others_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  others_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  others_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  others_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  others_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  others_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  others_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",

  cs_min_bet_required: "đặt cược tối thiểu là bắt buộc.",
  cs_max_bet_required: "đặt cược tối thiểu là bắt buộc.",
  cs_max_per_match_required: "đặt cược tối đa cho mỗi trận đấu là cần thiết",
  cs_bet_limit_exists: "Giới hạn đặt cược là đã tồn tại.",
  cs_parent_bet_limit_not_exists: "Giới hạn đặt cược phụ huynh không tồn tại.",
  cs_account_min_bet_lt_parent: "Tài khoản tối thiểu đặt cược thấp hơn cấp cha.",
  cs_account_max_bet_gt_parent: "Tài khoản đặt cược tối đa lớn hơn cấp cha.",
  cs_account_max_per_match_gt_parent: "Tài khoản tối đa đặt cược mỗi trận đấu lớn hơn cấp cha.",

  used_credit_gt_credit_limit: "Hạn mức tín dụng đã qua sử dụng lớn hơn hạn mức tín dụng.",
  bet_limit_setting_not_exists: "Giới hạn đặt cược thiết lập không tồn tại.",
  parent_bet_limit_setting_not_exists: "Thiết lập giới hạn đặt cược cấp cha  không tồn tại.",
  package_not_exists_in_parent: "Thiết lập gói giới hạn đặt cược cấp cha không tồn tại",
  soccer_bet_limit_setting_not_exists: "Thiết lập giới hạn cược bóng đá không tồn tại.",
  soccer_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  basketball_bet_limit_setting_not_exists: "Thiết lập giới hạn đặt cược Bóng rổ  không tồn tại",
  basketball_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  tennis_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược tennis  không tồn tại.",
  tennis_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  baseball_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược bóng chày  không tồn tại.",
  baseball_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  parlay_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược  xiên  không tồn tại.",
  parlay_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  esports_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược thể thao điện tử  không tồn tại.",
  esports_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  others_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược của các loại khác  không tồn tại.",
  others_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",

  cs_bet_limit_setting_not_exists:"Thiết lập giới hạn đặt cược của các loại khác  không tồn tại.",
  cs_update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",

  soccer_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược bóng đá của cấp cha không tồn tại.",
  soccer_min_bet_lt_parent: "Cược tối thiểu bóng đá của tài khoản con nhỏ hơn cấp cha.",
  soccer_max_bet_gt_parent: "Cược tối đa bóng đá của tài khoản con lớn hơn cấp cha.",
  soccer_max_per_match_gt_parent: "Cược tối đa mỗi trận bóng đá của tài khoản con lớn hơn cấp cha.",
  basketball_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược bóng rổ của cấp cha không tồn tại.",
  basketball_min_bet_lt_parent: "Cược tối thiểu bóng rổ của tài khoản con nhỏ hơn cấp cha.",
  basketball_max_bet_gt_parent: "Cược tối đa bóng rổ của tài khoản con lớn hơn cấp cha.",
  basketball_max_per_match_gt_parent: "Cược tối đa mỗi trận bóng rổ của tài khoản con lớn hơn cấp cha.",
  tennis_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược Tennis của cấp cha không tồn tại.",
  tennis_min_bet_lt_parent: "Cược tối thiểu Tennis của tài khoản con nhỏ hơn cấp cha.",
  tennis_max_bet_gt_parent: "Cược tối đa Tennis của tài khoản con lớn hơn cấp cha.",
  tennis_max_per_match_gt_parent: "Cược tối đa mỗi trận Tennis của tài khoản con lớn hơn cấp cha.",
  baseball_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược bóng chày của cấp cha không tồn tại.",
  baseball_min_bet_lt_parent: "Cược tối thiểu bóng chày của tài khoản con nhỏ hơn cấp cha.",
  baseball_max_bet_gt_parent: "Cược tối đa bóng chày của tài khoản con lớn hơn cấp cha.",
  baseball_max_per_match_gt_parent: "Cược tối đa mỗi trận bóng chày của tài khoản con lớn hơn cấp cha.",
  parlay_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược xiên của cấp cha không tồn tại.",
  parlay_min_bet_lt_parent: "Cược tối thiểu xiên của tài khoản con nhỏ hơn cấp cha.",
  parlay_max_bet_gt_parent: "Cược tối đa xiên của tài khoản con lớn hơn cấp cha.",
  parlay_max_per_match_gt_parent: "Cược tối đa mỗi trận xiên của tài khoản con lớn hơn cấp cha.",
  esports_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược thể thao điện tử của cấp cha không tồn tại.",
  esports_min_bet_lt_parent: "Cược tối thiểu thể thao điện tử của tài khoản con nhỏ hơn cấp cha.",
  esports_max_bet_gt_parent: "Cược tối đa thể thao điện tử của tài khoản con lớn hơn cấp cha.",
  esports_max_per_match_gt_parent: "Cược tối đa mỗi trận thể thao điện tử của tài khoản con lớn hơn cấp cha.",
  others_parent_bet_limit_setting_not_exists: "Thiết lập giới hạn cược của các loại khác của cấp cha không tồn tại.",
  others_min_bet_lt_parent: "Cược tối thiểu thể thao điện tử của tài khoản con nhỏ hơn cấp cha.",
  others_max_bet_gt_parent: "Cược tối đa thể thao điện tử của tài khoản con lớn hơn cấp cha.",
  others_max_per_match_gt_parent: "Cược tối đa mỗi trận thể thao điện tử của tài khoản con lớn hơn cấp cha.",

  cs_parent_bet_limit_setting_not_exists: "Việc đặt giới hạn đặt cược cho các loại điểm chính xác ở cấp độ gốc không tồn tại.",
  cs_min_bet_lt_parent: "Đặt cược điểm tối thiểu chính xác của tài khoản con nhỏ hơn tài khoản gốc.",
  cs_max_bet_gt_parent: "Số điểm đặt cược tối đa chính xác của tài khoản con lớn hơn của tài khoản mẹ.",
  cs_max_per_match_gt_parent: "Mức đặt cược tối đa của tài khoản con cho mỗi trận đấu có tỷ số chính xác lớn hơn mức đặt cược của tài khoản gốc.",

  cs_min_bet_lt_soccer: "Đặt cược tỷ số tối thiểu chính xác thấp hơn đặt cược tối thiểu bóng đá.",
  cs_max_bet_gt_soccer: "Cược tỷ số tối đa chính xác lớn hơn cược tối đa bóng đá.",
  cs_max_per_match_gt_soccer: "Tỷ số chính xác tối đa mỗi trận lớn hơn tỷ số tối đa bóng đá mỗi trận.",

  update_interval_violated: "Khoảng thời gian cập nhật vi phạm.",
  exceeded_parent_others: "Đã vượt quá thiết lập hoa hồng cấp cha.",
  exceeded_parent_hdp: "Đã vượt quá thiết lập cược HDP cấp cha.",
  soccer_min_bet_gt_max_bet: "Bóng Đá Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  soccer_max_bet_gt_max_per_match: "Bóng Đá Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  basketball_min_bet_gt_max_bet: "Bóng Rổ Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  basketball_max_bet_gt_max_per_match: "Bóng Rổ Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  tennis_min_bet_gt_max_bet: "Quần Vợt Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  tennis_max_bet_gt_max_per_match: "Quần Vợt Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  baseball_min_bet_gt_max_bet: "Bóng Chày Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  baseball_max_bet_gt_max_per_match: "Bóng Chày Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  parlay_min_bet_gt_max_bet: "Đặt Cựơc Dồn Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  parlay_max_bet_gt_max_per_match: "Đặt Cựơc Dồn Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  esports_min_bet_gt_max_bet: "Thể thao điện tử Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  esports_max_bet_gt_max_per_match: "Thể thao điện tử Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  others_min_bet_gt_max_bet: "Thể loại khác Đặt cược tối thiểu phải thấp hơn hoặc bằng với Đặt cược tối đa.",
  others_max_bet_gt_max_per_match: "Thể loại khác Đặt cược tối đa phải thấp hơn hoặc bằng Tối Đa Cho Mỗi Trận.",
  cs_min_bet_gt_max_bet: "Tỷ số chính xác Hạng mục Cược tối thiểu phải thấp hơn hoặc bằng Cược tối đa.",
  cs_others_max_bet_gt_max_per_match: "Tỷ số chính xác Hạng mục Đặt cược tối đa phải nhỏ hơn hoặc bằng Tối đa mỗi trận đấu.",

  validAmount: "Please enter a valid amount",
  valid: "{fname} chứa ít nhất một chữ hoa, một chữ thường và một số. (Ví dụ: Abcd1234)",
  notSame: "Mật khẩu mới không được giống với mật khẩu cũ."
};